export default class likeListState {
  constructor(app) {
    this.app = app;

    /**
     * Whether or not the flags are loading.
     *
     * @type {Boolean}
     */
    this.loading = false;
  }

  /**
   * Load flags into the application's cache if they haven't already
   * been loaded.
   */
  load() {
    if (this.cache && !this.app.session.user.attribute('newLikeCount')) {
      return;
    }

    this.loading = true;
    m.redraw();

    this.app.store
      .find('posts')
      .then((posts) => {
        this.app.session.user.pushAttributes({ newLikeCount: 0 });
        this.cache = posts.sort((a, b) => b.createdAt() - a.createdAt());
      })
      .catch(() => {})
      .then(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
